import * as React from "react";
import Elegi from "../elegi/index";
import Contrata from "../contrata/index";
import Contrataste from "../contrataste/index";

export default class StepsSwitch extends React.Component {
  state = {
    step: 1,
    id_contrata: "",
    id_cotizacion: "",
    plan_selected: ""
  };

  prevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  };

  nextStep = () => {
    const { step } = this.state;
    this.setState({ step: step + 1 });
  };

  // Actualiza el ID contrata y el ID cotización que llegan desde el back durante el Step 1
  updateIds = (idContrata, idCotizacion) => {
    this.setState({ id_contrata: idContrata, id_cotizacion: idCotizacion})
  }

  // Actualiza el plan seleccionado que se muestra en el Step 2 cuando se hace click en "contrata ahora" durante el Step 1
  planSelected = (plan) => {
    this.setState({ plan_selected: plan });
  }

  render() {
    const { step } = this.state;
    switch (step) {
      case 1:
        return (
          <Elegi
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            updateIds={this.updateIds}
            planSelected={this.planSelected}
          ></Elegi>
        );
      case 2:
        return (
          <Contrata
            prevStep={this.prevStep}
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            idCotizacion={this.state.id_cotizacion}
            idContrata={this.state.id_contrata}
            planSelected={this.state.plan_selected}
          ></Contrata>
        );
      case 3:
        return (
          <Contrataste
            prevStep={this.prevStep}
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            planSelected={this.state.plan_selected}
          ></Contrataste>
        );
      default:
      // No hace nada
    }
  }
}
